import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import {ActivatedRoute, RouterLink} from "@angular/router";
import {NavigationRouteItem} from "../../services/navigation-state.service";
import {ComponentBase} from "../component-base/component-base.component";
import {NgClass, NgForOf, NgIf, NgTemplateOutlet, UpperCasePipe} from "@angular/common";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";


@Component({
  selector: 'layout-content-header',
  templateUrl: './layout-content-header.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    MatToolbarModule,
    RouterLink,
    MatIconModule,
    UpperCasePipe,
    NgForOf,
    NgClass
  ],
  styleUrls: ['./layout-content-header.component.sass']
})
export class LayoutContentHeaderComponent extends ComponentBase implements OnInit {


  @Input() customButtonsTemplate?: TemplateRef<any>
  @Input() lastNavigationItemTemplate?: TemplateRef<{
    navigationItem?: NavigationRouteItem,
    debug?: boolean
  }>
  @Input() breadcrumbs?: NavigationRouteItem[]

  get lastNavigationRouteItem(): NavigationRouteItem | undefined {
    if (this.breadcrumbs && this.breadcrumbs.length) {
      return this.breadcrumbs[this.breadcrumbs.length - 1]
    }
    return undefined
  }

  get breadcrumbsClass() {
    const last = this.lastNavigationRouteItem
    if (last && last.data && 'breadcrumbsNgClass' in last.data) {
      return last.data['breadcrumbsNgClass']
    }
    return 'mb-4'
  }

  get hideHeader(): boolean {
    return this.lastNavigationRouteItem?.hideHeader || false
  }


  constructor(
    readonly activatedRoute: ActivatedRoute
  ) {
    super()
  }
}
